import React from 'react';
import { ArrowRight, Calendar, MapPin, Briefcase } from 'lucide-react';
import { Link } from 'react-router-dom';
import { getCaseStudyPath } from '../../data/caseStudies';

const formatDate = (date, locale) => {
  if (!date) return null;

  return new Intl.DateTimeFormat(locale === 'sk' ? 'sk-SK' : 'en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date(date));
};

const CaseStudyCard = ({ study, ui }) => {
  const { content, locale } = study;
  const imageAlt = content.imageAlt || study.imageAlt || content.tagline;
  const industry = content.industry || study.industry;
  const location = content.location || study.location;
  const description = content.cardDescription || content.summary || content.metaDescription;

  return (
    <Link
      to={getCaseStudyPath(locale, study.slug)}
      className="case-study-card group"
    >
      <div className="case-study-card-image-wrap">
        {study.image ? (
          <img
            src={study.image}
            alt={imageAlt}
            className="case-study-card-image"
            loading="lazy"
          />
        ) : (
          <div className="case-study-card-placeholder" aria-hidden="true" />
        )}
      </div>

      <div className="case-study-card-body">
        <div className="case-study-card-meta">
          {study.publishedDate && (
            <span>
              <Calendar className="h-3.5 w-3.5" />
              {formatDate(study.publishedDate, locale)}
            </span>
          )}
          {industry && (
            <span>
              <Briefcase className="h-3.5 w-3.5" />
              {industry}
            </span>
          )}
          {location && (
            <span>
              <MapPin className="h-3.5 w-3.5" />
              {location}
            </span>
          )}
        </div>

        <h2 className="case-study-card-title">{content.tagline}</h2>
        <p className="case-study-card-description">
          {description}
        </p>

        {content.results?.metrics?.length > 0 && (
          <div className="case-study-card-metrics">
            {content.results.metrics.slice(0, 3).map((metric) => (
              <div key={`${metric.label}-${metric.value}`}>
                <strong>{metric.value}</strong>
                <span>{metric.label}</span>
              </div>
            ))}
          </div>
        )}

        <div className="case-study-card-link">
          {ui.viewCaseStudy}
          <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
        </div>
      </div>
    </Link>
  );
};

export default CaseStudyCard;
